import {useMutation} from '@tanstack/react-query'
import {useAddBookingApiMethod} from 'api/useAddBookingApiMethod'
import {useCreateOrderApiMethod} from 'api/useCreateOrderApiMethod'
import {useGetOrderApiMethod} from 'api/useGetOrderApiMethod'
import {Basic, Ventrata} from 'types'

type Params = {
  optionalOrderId?: string
  bookingUuid: string
  productId: string
  optionId: string
  availabilityId: string
  unitItems: Ventrata.RequestUnitItem[]
  currency: Basic.Currency
}

export const useAddBookingMutation = () => {
  const getOrder = useGetOrderApiMethod()
  const createOrder = useCreateOrderApiMethod()
  const addBooking = useAddBookingApiMethod()

  return useMutation({
    mutationFn: async ({
      optionalOrderId,
      bookingUuid,
      productId,
      optionId,
      availabilityId,
      unitItems,
      currency,
    }: Params) => {
      const getOrderId = async (optionalOrderId?: string) => {
        if (optionalOrderId) {
          return optionalOrderId
        }

        const order = await createOrder({
          currency,
          expirationMinutes: 30,
        })

        return order.id
      }

      const orderId = await getOrderId(optionalOrderId)

      await addBooking({
        orderId,
        bookingUuid,
        productId,
        optionId,
        unitItems,
        availabilityId,
      })

      return await getOrder(orderId)
    },
  })
}
